module.exports = __webpack_public_path__ + "477ec210a419757d2430fde98f8bfaba.pdf";